// Validation helpers

const NAME_REGEX = /^[A-Za-z ]+$/; // alphabets + spaces
const USER_PASS_ALLOWED = /^[A-Za-z0-9!@#$%^&*._-]+$/; // letters, numbers + specials
const GMAIL_REGEX = /^[A-Za-z0-9._%+-]+@gmail\.com$/;
const PHONE_REGEX = /^\+\d{6,15}$/; // + followed by 6–15 digits

export function validateName(value) {
  if (!value) return "Name is required";
  if (!NAME_REGEX.test(value)) return "Only alphabets and spaces allowed";
  return "";
}

export function validateUsername(value) {
  if (!value) return "Username is required";
  if (!USER_PASS_ALLOWED.test(value))
    return "Username can contain letters, numbers, and !@#$%^&*._-";
  return "";
}

export function validatePassword(value, username) {
  if (!value) return "Password is required";
  if (!USER_PASS_ALLOWED.test(value))
    return "Password can contain letters, numbers, and !@#$%^&*._-";
  if (username && value === username)
    return "Password cannot be the same as username";
  return "";
}

export function validateConfirmPassword(confirm, password) {
  if (!confirm) return "Confirm your password";
  if (confirm !== password) return "Passwords do not match";
  return "";
}

export function validateEmail(value) {
  if (!value) return "Email is required";
  if (!GMAIL_REGEX.test(value))
    return "Email must be a valid Gmail (e.g. name@gmail.com)";
  return "";
}

export function validatePhone(value) {
  if (!value) return "Phone number is required";
  if (!PHONE_REGEX.test(value))
    return "Use format like +2348012345678 (with country code)";
  return "";
}
